<template>
  <div>
    <wt-radio-box
      v-for="restriction in restrictionOptions"
      :key="restriction.value"
      group="restriction-options-group"
      :selected="restriction.value === contextFilters.restrictions"
      :value="restriction.value"
      :labelRight="restriction.label"
      @select="restrictionChanged"
    />
  </div>
</template>

<script>
import app from 'app';

export default {
  data() {
    return {
      restrictionOptions: [
        {
          label: 'All',
          value: null,
        },
        {
          label: 'No Restrictions',
          value: false,
        },
        {
          label: 'Restricted',
          value: true,
        },
      ],
    };
  },

  computed: Object.assign({}, app.Vuex.mapGetters(['contextFilters'])),

  props: {},

  methods: Object.assign(
    {
      restrictionChanged(value) {
        this.SET_RESTRICTION_SELECTION(value);
        this.$emit('search');
      },
    },
    app.Vuex.mapActions(['SET_RESTRICTION_SELECTION'])
  ),
};
</script>
